import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators }  from 'redux';
import {
  FILE_DOWNLOAD,
  GET_OBJECT_DOWNLOAD,
  GET_OBJECT_DOWNLOAD_SUCCESS,
  GET_OBJECT_DOWNLOAD_FAILURE
} from 'constants/ActionTypes';
import { getObjectDownloadToken } from "api/actions";
import { baseURL } from "api/client";
import { url } from 'utils';


class FileDownloader extends React.Component {
  componentWillReceiveProps(props) {
    switch(props.type) {
      case FILE_DOWNLOAD:
        if (props.hasOwnProperty('id')) {
          props.getObjectDownloadToken({ id: props.id })
        }
        break;
      case GET_OBJECT_DOWNLOAD:
        break;
      case GET_OBJECT_DOWNLOAD_SUCCESS:
        if (props.hasOwnProperty('downloadToken') && props.hasOwnProperty('downloadName')) {
          const { downloadToken, downloadName: name } = props;
          url.downloadUrl(name, `${baseURL}/objects/downloadbytoken/${downloadToken}`)
        }
        break;
      case GET_OBJECT_DOWNLOAD_FAILURE:
        break;
    }
  }

  render() {
    return (
      <Fragment>
      </Fragment>
    );
  }
}

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ getObjectDownloadToken }, dispatch)
};

const mapStateToProps = (state) => ({
  downloadName: state.downloadName,
  downloadToken: state.downloadToken,
  errorMessage: state.errorMessage,
  id: state.id,
  type: state.type,
});

export default connect(mapStateToProps, dispatchToProps)(
  FileDownloader
);
